/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNullValue = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 4c-3.094 0-6 3.333-6 8 0 1.427.272 2.729.737 3.849l9.5-9.5C15.117 4.872 13.583 4 12 4zm5.662.924 2.63-2.631 1.415 1.414-2.946 2.946C19.553 8.228 20 10.077 20 12c0 5.274-3.362 10-8 10-2.277 0-4.247-1.14-5.662-2.924l-2.63 2.631-1.415-1.414 2.946-2.946C4.447 15.772 4 13.923 4 12 4 6.726 7.362 2 12 2c2.277 0 4.247 1.14 5.662 2.924zm-.399 3.227-9.5 9.5C8.883 19.128 10.417 20 12 20c3.094 0 6-3.333 6-8 0-1.427-.271-2.729-.737-3.849z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgNullValue as NullValue };
